import React from "react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import swal from "sweetalert";
import ReactPaginate from "react-paginate";
import { getCookie } from "../../inc/cookies";
import config from "../../inc/config";
import { isoToDateTime, priceFormat } from "../../inc/helper";

class AuctionsModule extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,

      auctions: [],

      filterId: '',
      filterTitle: '',
      filterDescription: '',
      filterProvider: '',
      filterStartStartDate: '',
      filterEndStartDate: '',


      pageCount: 0,
      resultCount: 0,
      currentPage: 1,
      limit: 10
    };
  }

  componentDidMount() {
    const searchParams = new URLSearchParams(window.location.search);
    const currentPage = parseInt(searchParams.get("page")) || 1;
  
    this.setState({
      currentPage,
      filterId: searchParams.get("filterId") || '',
      filterTitle: searchParams.get("filterTitle") || '',
      filterDescription: searchParams.get("filterDescription") || '',
      filterProvider: searchParams.get("filterProvider") || '',
      filterStartStartDate: searchParams.get("filterStartStartDate") || '',
      filterEndStartDate: searchParams.get("filterEndStartDate") || '',
    }, () => {
      this.getAuctions(this.state.currentPage);
    });
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {}

  getAuctions(currentPage) {
    const { filterId, filterTitle, limit, filterDescription, filterProvider, filterStartStartDate, filterEndStartDate } = this.state;
    let sessionHash = getCookie("sessionHash");
    this.setState({isLoading: true});

    const requestOptions = {
      method: "GET",
      headers: { Authorization: "Bearer " + sessionHash },
    };

    let query = `limit=${limit}&page=${currentPage}`;
    if (filterId) query += `&filterId=${filterId}`;
    if (filterTitle) query += `&filterTitle=${encodeURIComponent(filterTitle)}`;
    if (filterDescription) query += `&filterDescription=${filterDescription}`;
    if (filterProvider) query += `&filterProvider=${filterProvider}`;
    if (filterStartStartDate) query += `&filterStartStartDate=${filterStartStartDate}`;
    if (filterEndStartDate) query += `&filterEndStartDate=${filterEndStartDate}`;

    fetch(config.restApi + `auctions/tr?${query}`, requestOptions)
      .then((response) => response.json())
      .then(
        (responseData) => {
          switch (responseData.status) {
            case 200:
              this.setState({isLoading: false, auctions: responseData.auctions, pageCount: responseData.pageCount, resultCount: responseData.resultCount, currentPage: currentPage});
            break;
            case 401:
              swal({
                dangerMode: true,
                icon: 'warning',
                title: 'Hay Aksi',
                text: responseData.message,
                buttons: 'Tamam'
              }).then(this.props.navigate('/home'))
            break;
            default:
              swal({
                dangerMode: true,
                icon: "warning",
                title: "Hay Aksi",
                text: responseData.message,
                buttons: "Tamam",
              }).then(this.setState({isLoading: false}));
              break;
          }
        },
        () =>
          swal({
            dangerMode: true,
            icon: "error",
            title: "Bağlantı Hatası",
            text: "Lütfen internet bağlantınızı kontrol ediniz.",
            buttons: "Tamam",
          })
      );
  }

  handlePageClick(page) {
    // URL parametrelerini güncellemek için URLSearchParams kullanıyoruz
    const params = new URLSearchParams(window.location.search);
  
    // Mevcut sayfa parametresini güncelliyoruz
    params.set('page', page.selected + 1);  // sayfa numarası 0-indexed olduğu için +1 ekliyoruz
  
    // Yeni URL'yi oluşturuyoruz
    const newUrl = `${window.location.pathname}?${params.toString()}`;
    
    // URL'yi güncelliyoruz (browser history'yi de değiştiriyoruz, sayfa yenilenmeden)
    window.history.pushState(null, '', newUrl);
    
    this.setState({ currentPage: page.selected + 1 }, () => {this.getAuctions(this.state.currentPage);});
  }

  filterOnClick = () => {
    const params = new URLSearchParams();
  
    if (this.state.currentPage) params.append('page', 1);
    if (this.state.filterId) params.append('filterId', this.state.filterId);
    if (this.state.filterTitle) params.append('filterTitle', this.state.filterTitle);
    if (this.state.filterDescription) params.append('filterDescription', this.state.filterDescription);
    if (this.state.filterProvider) params.append('filterProvider', this.state.filterProvider);
    if (this.state.filterStartStartDate) params.append('filterStartStartDate', this.state.filterStartStartDate);
    if (this.state.filterEndStartDate) params.append('filterEndStartDate', this.state.filterEndStartDate);
  
    const queryString = params.toString();
    this.props.navigate(`?${queryString}`);
  
    this.getAuctions(1); // Sayfa 1'den başla
  };

  resetOnClick = () => {
    this.setState({
      filterId: '',
      filterTitle: '',
      filterDescription: '',
      filterProvider: '',
      filterStartStartDate: '',
      filterEndStartDate: ''
    }, () => {
      this.getAuctions(1); // Sayfa 1'den başla
  
      // URL'deki tüm parametreleri kaldır
      this.props.navigate('?'); // URL'yi temizle
    });
  };

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.filterOnClick();
    }
  };

  render() {
    return this.state.isLoading ? (
      <div className="ibox-content sk-loading position-static">
        <div className="sk-spinner sk-spinner-fading-circle">
          <div className="sk-circle1 sk-circle"></div>
          <div className="sk-circle2 sk-circle"></div>
          <div className="sk-circle3 sk-circle"></div>
          <div className="sk-circle4 sk-circle"></div>
          <div className="sk-circle5 sk-circle"></div>
          <div className="sk-circle6 sk-circle"></div>
          <div className="sk-circle7 sk-circle"></div>
          <div className="sk-circle8 sk-circle"></div>
          <div className="sk-circle9 sk-circle"></div>
          <div className="sk-circle10 sk-circle"></div>
          <div className="sk-circle11 sk-circle"></div>
          <div className="sk-circle12 sk-circle"></div>
        </div>
      </div>
    ) : (
      <div className="row custom-container">
        <div className="col-xl-9">
          <div className="ibox">
            <div className="ibox-title d-flex justify-content-between pr-3">
              <strong className="text-black">İhaleler</strong>
              <Link className="btn btn-orange" title="İhale Ekle" to={"/auctionAdd"}><i className="fa fa-plus"></i></Link>
            </div>
            <div className="table-responsive-lg mb-5">
              <table className="table table-bordered text-center">
                <thead>
                  <tr className="text-black">
                    <th>İhale No</th>
                    <th>İhale Adı</th>
                    <th>İhale Açıklaması</th>
                    <th>Sağlayıcı</th>
                    <th>Başlangıç Tarihi</th>
                    <th>Bitiş Tarihi</th>
                    <th>Detay</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.auctions.map((auction, index) =>
                    <tr key={index}>
                      <td className="align-middle">{auction.id}</td>
                      <td className="align-middle">{auction.title}</td>
                      <td className="align-middle">{auction.description}</td>
                      <td className="align-middle">{auction.provider}</td>
                      <td className="align-middle">{isoToDateTime(auction.startDate)}</td>
                      <td className="align-middle">{isoToDateTime(auction.endDate)}</td>
                      <td className="align-middle" style={{minWidth:98.5}}>
                        <Link className="btn btn-orange m-1" title="Düzenle" to={`/auctionEdit?id=${auction.id}`}><i className="fa fa-pencil"></i></Link>
                        <Link className="btn btn-darkblue" title="İhale Araçları" to={`/auctionItems?auctionId=${auction.id}`}><i className="fa fa-car"></i></Link>
                      </td>
                    </tr>
                  )}
                  {this.state.auctions.length === 0 && <tr><td className="align-middle text-darkblue p-3" colSpan="7">İhale Bulunamadı !</td></tr>}
                </tbody>
              </table>
            </div>
            {this.state.auctions.length !== 0 &&
            <ReactPaginate
              previousLabel={"Geri"}
              nextLabel={"İleri"}
              breakLabel={"..."}  
              pageCount={this.state.pageCount}
              marginPagesDisplayed={1}
              onPageChange={page => this.handlePageClick(page)}
              pageRangeDisplayed={10}
              containerClassName={'pagination'}
              activeClassName={'activePage'}
              forcePage={Number(this.state.currentPage) - 1}
            />
            }
          </div>
        </div>
        <div className="col-xl-3 order-first order-xl-last d-xl-none" id="accordion">
          <div className="ibox">
            <div className="ibox-content text-darkblue p-0">
              <h4 className="collapse-title">
                <a className="btn btn-link text-darkblue font-bold d-flex justify-content-between" data-toggle="collapse" href="#filterCollapse" title="Filtrele">Filtrele</a>
              </h4>
            </div>
            <div className="collapse" data-parent="#accordion" id="filterCollapse">
              <div className="ibox-content text-darkblue">  
                <strong>İhale No</strong>
                <input className="form-control form-input mb-2 mt-1" onChange={event => this.setState({filterId: event.target.value.replace(/\D+/g, '')})} onKeyDown={this.handleKeyPress} placeholder="İhale No" type="text" value={this.state.filterId}/>
                <strong>İhale Adı</strong>
                <input className="form-control form-input mb-2 mt-1" onChange={event => this.setState({filterTitle: event.target.value})} onKeyDown={this.handleKeyPress} placeholder="İhale Adı" type="text" value={this.state.filterTitle}/>
                <strong>İhale Açıklaması</strong>
                <input className="form-control form-input mb-2 mt-1" onChange={event => this.setState({filterDescription: event.target.value})} onKeyDown={this.handleKeyPress} placeholder="Açıklama" type="text" value={this.state.filterDescription}/>
                <strong>Sağlayıcı</strong>
                <input className="form-control form-input mb-2 mt-1" onChange={event => this.setState({filterProvider: event.target.value})} onKeyDown={this.handleKeyPress} placeholder="Sağlayıcı" type="text" value={this.state.filterProvider}/>
                <strong>Başlangıç Tarihi</strong>
                <input className="form-control form-inputt mb-2 mt-1" onChange={event => this.setState({filterStartStartDate: event.target.value})} onKeyDown={this.handleKeyPress} type="date" value={this.state.filterStartStartDate}/>
                <strong>Bitiş Tarihi</strong>
                <input className="form-control form-input" onChange={event => this.setState({filterEndStartDate: event.target.value})} onKeyDown={this.handleKeyPress} type="date" value={this.state.filterEndStartDate} />
                <div className="d-flex justify-content-end">
                  <button className="btn btn-orange mt-3 mr-2" onClick={this.resetOnClick}><i className="fa fa-refresh"></i> Sıfırla</button>
                  <button className="btn btn-orange mt-3" onClick={this.filterOnClick}><i className="fa fa-filter"></i> Filtrele</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 order-first order-xl-last d-none d-xl-block">
          <div className="ibox">
            <div className="ibox-title text-darkblue">
              <h5><i className="fa fa-filter"></i> Filtrele</h5>
            </div>
            <div className="ibox-content text-darkblue">
              <strong>İhale No</strong>
              <input className="form-control form-input mb-2 mt-1" onChange={event => this.setState({filterId: event.target.value.replace(/\D+/g, '')})} onKeyDown={this.handleKeyPress} placeholder="İhale No" type="text" value={this.state.filterId}/>
              <strong>İhale Adı</strong>
              <input className="form-control form-input mb-2 mt-1" onChange={event => this.setState({filterTitle: event.target.value})} onKeyDown={this.handleKeyPress} placeholder="İhale Adı" type="text" value={this.state.filterTitle}/>
              <strong>İhale Açıklaması</strong>
              <input className="form-control form-input mb-2 mt-1" onChange={event => this.setState({filterDescription: event.target.value})} onKeyDown={this.handleKeyPress} placeholder="İhale Açıklaması" type="text" value={this.state.filterDescription}/>
              <strong>Sağlayıcı</strong>
              <input className="form-control form-input mb-2 mt-1" onChange={event => this.setState({filterProvider: event.target.value})} onKeyDown={this.handleKeyPress} placeholder="Sağlayıcı" type="text" value={this.state.filterProvider}/>
              <strong>Başlangıç Tarihi</strong>
              <input className="form-control form-inputt mb-2 mt-1" onChange={event => this.setState({filterStartStartDate: event.target.value})} onKeyDown={this.handleKeyPress} type="date" value={this.state.filterStartStartDate}/>
              <strong>Bitiş Tarihi</strong>
              <input className="form-control form-input" onChange={event => this.setState({filterEndStartDate: event.target.value})} onKeyDown={this.handleKeyPress} type="date" value={this.state.filterEndStartDate} />
              <div className="d-flex justify-content-end">
                <button className="btn btn-orange mt-3 mr-2" onClick={this.resetOnClick}><i className="fa fa-refresh"></i> Sıfırla</button>
                <button className="btn btn-orange mt-3" onClick={this.filterOnClick}><i className="fa fa-filter"></i> Filtrele</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default function Auctions(props) {
  return (
    <AuctionsModule navigate={useNavigate()} searchParams={useSearchParams()[0]}></AuctionsModule>
  );
}
